export default {
  PotentialMineral: 0, 
  Inferred: 1,
  Indicated: 2,
  Measured: 3,
  Probable: 4,
  Proven: 5
};